<!-- Desktop Footer - Full version for medium screens and up -->
<footer class="w-full py-bosch-lg mt-bosch-xl hidden md:block bg-bosch-gray-50 border-t border-bosch-gray-200">
<div id="HTML-Row7" class="flex flex-nowrap items-center justify-center gap-bosch-md max-w-screen-md mx-auto text-center text-sm font-bosch">
  
  <!-- Grouped "Powered by" and StableLinks as one menu item -->
  <div class="flex-1 flex items-center justify-center gap-bosch-sm">
    <span class="text-bosch-gray-600 font-bosch-medium whitespace-nowrap">Powered by:</span>
    <a
      href="https://inside-docupedia.bosch.com/confluence/display/semanticAPiService/Stable+Links+Home"
      target="_blank"
      aria-label="Read more on Docupedia about Stable Links"
      rel="noopener"
      class="hover:opacity-80 transition-opacity duration-200"
    >
      <img src="../ui/assets/img/_slnk.svg" alt="StableLinks" class="w-14 h-14" />
    </a>
  </div>

  <a
    href="https://boschdigital.qualtrics.com/jfe/form/SV_et9eWrQTWuzZym2?Referrer=rb-ux-studio&Offering=Bosch+URL+Shortener&OfferingID=FB-0000606&Source=Web+Application&SourceCategory=Inform&Stage=Prod&SurveyStyle=Fullscreen"
    target="_blank"
    rel="noopener"
    class="flex-1 text-center whitespace-nowrap text-bosch-blue-500 hover:text-bosch-blue-600 hover:underline transition-all duration-200 cursor-pointer"
  >
    Feedback
  </a>

  <a
    href="https://teams.microsoft.com/l/channel/19%3A75c45d43acbe49a48bae1b48a205ee7c%40thread.tacv2/Support%20Channel?groupId=74852057-7212-407b-a488-379266fe8991&tenantId=0ae51e19-07c8-4e4b-bb6d-648ee58410f4"
    target="_blank"
    rel="noopener"
    class="flex-1 text-center whitespace-nowrap text-bosch-blue-500 hover:text-bosch-blue-600 hover:underline transition-all duration-200 cursor-pointer"
  >
    Teams Channel
  </a>

  <a [href]="getEmailTemplate()" target="_blank" rel="noopener" class="flex-1 text-center whitespace-nowrap text-bosch-blue-500 hover:text-bosch-blue-600 hover:underline transition-all duration-200 cursor-pointer">
    Open Ticket
  </a>

  <a
    href="https://teams.microsoft.com/l/channel/19%3AD4GvIr6b9Z9K9EZ8YNpKKHZiOGE-9fKhBEeB-IJc4rY1%40thread.tacv2/News%20Feed?groupId=74852057-7212-407b-a488-379266fe8991&tenantId=0ae51e19-07c8-4e4b-bb6d-648ee58410f4"
    target="_blank"
    rel="noopener"
    class="flex-1 text-center whitespace-nowrap text-bosch-blue-500 hover:text-bosch-blue-600 hover:underline transition-all duration-200 cursor-pointer"
  >
    News Feed
  </a>

  <a (click)="aboutDialog.show()" class="flex-1 text-center whitespace-nowrap text-bosch-blue-500 hover:text-bosch-blue-600 hover:underline transition-all duration-200 cursor-pointer">
    About
  </a>

  <a target="_blank" href="https://bos.ch/dev" rel="noopener" class="hover:opacity-80 transition-opacity duration-200">
    <img src="../ui/assets/img/IDE.svg" alt="bos.ch/dev" class="w-10 h-10" />
  </a>
</div>
</footer>

<!-- Mobile Footer - Simplified version for small screens -->
<footer class="w-full py-bosch-md mt-bosch-lg block md:hidden bg-bosch-gray-50 border-t border-bosch-gray-200">
  <div class="flex flex-col gap-bosch-sm max-w-screen-sm mx-auto px-bosch-md">
    
    <!-- Single row: Powered by logo and menu links -->
    <div class="flex items-center justify-between">
      <!-- Powered by StableLinks -->
      <div class="flex items-center gap-bosch-xs">
        <span class="text-bosch-gray-600 font-bosch-medium text-xs">Powered by:</span>
        <a
          href="https://inside-docupedia.bosch.com/confluence/display/semanticAPiService/Stable+Links+Home"
          target="_blank"
          aria-label="Read more on Docupedia about Stable Links"
          rel="noopener"
          class="hover:opacity-80 transition-opacity duration-200"
        >
          <img src="../ui/assets/img/_slnk.svg" alt="StableLinks" class="w-10 h-10" />
        </a>
      </div>
      
      <!-- Menu links -->
      <div class="flex items-center gap-bosch-md">
        <a
          href="https://boschdigital.qualtrics.com/jfe/form/SV_et9eWrQTWuzZym2?Referrer=rb-ux-studio&Offering=Bosch+URL+Shortener&OfferingID=FB-0000606&Source=Web+Application&SourceCategory=Inform&Stage=Prod&SurveyStyle=Fullscreen"
          target="_blank"
          rel="noopener"
          class="text-bosch-blue-500 hover:text-bosch-blue-600 hover:underline transition-all duration-200 cursor-pointer text-sm font-bosch-medium"
        >
          Feedback
        </a>
        
        <a [href]="getEmailTemplate()" target="_blank" rel="noopener" class="text-bosch-blue-500 hover:text-bosch-blue-600 hover:underline transition-all duration-200 cursor-pointer text-sm font-bosch-medium">
          Open Ticket
        </a>
        
        <a (click)="aboutDialog.show()" class="text-bosch-blue-500 hover:text-bosch-blue-600 hover:underline transition-all duration-200 cursor-pointer text-sm font-bosch-medium">
          About
        </a>
      </div>
    </div>
    
    <!-- Copyright -->
    <div class="text-center">
      <span class="text-bosch-gray-600 font-bosch text-xs">
        © Robert Bosch GmbH {{ compiledTimestamp | date : "yyyy" }}, all rights reserved
      </span>
    </div>
  </div>
</footer>

<!-- Desktop Copyright - Full version for medium screens and up -->
<div id="HTML-Row9" class="w-full text-center py-bosch-lg mt-bosch-md hidden md:block text-sm">
  <span class="text-bosch-gray-600 font-bosch"
    >© Robert Bosch GmbH {{ compiledTimestamp | date : "yyyy" }}, all rights
    reserved</span
  >
</div>

<!-- About Dialog Component - Shared for both mobile and desktop -->
<app-about-dialog #aboutDialog></app-about-dialog>

